import SelectBox, { Item, SingleSelectBoxProps } from '@/components/select/SelectBox';
import { ALL_PLAN_CODES, PlanCode } from '@/models/Billing';
import { formatPlanCode } from '@/modules/billing/models/Plan';

type PlanCodeSelectBoxProps<T extends Item> = SingleSelectBoxProps<T> & {
  planCodes?: PlanCode[];
};

export interface PlanCodeItem extends Item {
  id: PlanCode;
  name: string;
}

const PlanCodeSelectBox = (props: PlanCodeSelectBoxProps<PlanCodeItem>) => {
  const { label = 'Plan', placeholder = 'Select plan', planCodes = ALL_PLAN_CODES } = props;

  const listPlanCodes = (): Promise<PlanCodeItem[]> => {
    return Promise.resolve(
      planCodes.map((planCode) => ({
        id: planCode,
        name: formatPlanCode(planCode),
      })),
    );
  };

  return (
    <SelectBox<PlanCodeItem>
      {...props}
      name="plan-code"
      label={label}
      placeholder={placeholder}
      queryFn={listPlanCodes}
    />
  );
};

export default PlanCodeSelectBox;
